export const generateIso8601Timestamp = () => {
  return new Date().toISOString().replace(/\.\d{3}Z$/, '+00:00');
};
